import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import { AuthProvider } from './context/AuthContext'
import App from './App.jsx'
import '@styles/global.css'

// AWS Amplify Configuration
const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_USER_POOL_ID || 'your-user-pool-id',
            userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || 'your-app-client-id',
            loginWith: {
                oauth: {
                    domain: import.meta.env.VITE_COGNITO_DOMAIN || 'your-cognito-domain',
                    scopes: ['email', 'profile', 'openid'],
                    redirectSignIn: [window.location.origin],
                    redirectSignOut: [window.location.origin],
                    responseType: 'code'
                }
            }
        }
    }
}

// Only configure Amplify if environment variables are set
if (import.meta.env.VITE_USER_POOL_ID && import.meta.env.VITE_USER_POOL_ID !== 'your-user-pool-id') {
    Amplify.configure(amplifyConfig)
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <App />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>,
)
